import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Email validation composable that provides access to email validation related getters and actions
 */
export function useEmailValidation() {
  const store = useStore();

  // Email validation getters
  const isEmailResent = computed(() => store.getters['emailValidation/GET_IS_VERIFICATION_EMAIL_SENT']);

  // Email validation actions
  const resendVerificationMail = () => store.dispatch('emailValidation/resendVerificationMail');

  return {
    // Getters
    isEmailResent,
    
    // Actions
    resendVerificationMail
  };
}
